export const EORIGIN_DATE_FORMAT = 'DD/MM/YYYY';
export const ISO_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
export const ISO_LOCAL_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const XML_DATE_FORMAT = 'YYYY-MM-DD';
export const EORIGIN_DATE_FORMAT_WITH_TIME = 'DD-MM-YY @ HH:mm';
export const DECO_DATE_FORMAT = 'YYYYMMDD';
export const DECO_DATE_FORMAT_WITH_TIME = 'YYYYMMDDHHmmss';
